import * as Yup from 'yup';

let sharedPostValidationSchema = {
    title: Yup.string()
    .max(100, 'Title should not exceed 100 characters'),
    shareDescription: Yup.string()
        .required('Description is required')
        .min(1, 'Title should be at least 1 character long')
        .max(1000, 'Title should not exceed 1000 characters'),
}


let nonSharedPostValidationSchema = {
    title: Yup.string()
    .max(100, 'Title should not exceed 100 characters'),
    hashtags: Yup.array()
        .of(
            Yup.string()
            // .matches(/^\S*$/, 'Text should not contain spaces') // No spaces allowed in each item
            .required('Tag is required')
        )
        .min(1, 'At least 1 hashtag is required')
        .max(10, 'No more than 10 hashtags allowed'),
    description: Yup.string()
        .required('Description is required')
        .min(1, 'Title should be at least 1 character long')
        .max(1000, 'Title should not exceed 1000 characters'),
}

export { sharedPostValidationSchema, nonSharedPostValidationSchema }
